const BASE = '/backend/api/admin-portal';

// Même protocole que l'API des échanges : cookie de session, jeton CSRF en en-tête.
export async function portalRequest(path, { method = 'GET', body, csrf, signal } = {}) {
  const response = await fetch(`${BASE}${path}`, {
    method, credentials: 'same-origin', cache: 'no-store', signal,
    headers: { ...(method !== 'GET' ? { 'Content-Type': 'application/json' } : {}), ...(csrf ? { 'X-Exchange-CSRF': csrf } : {}) },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw Object.assign(new Error(payload.message || 'Le service est momentanément indisponible.'), { status: response.status, details: payload.details });
  }
  return response.json();
}

// Recherche insensible aux accents et à la casse.
export const fold = (value) => String(value ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const formatDateTime = (value) => value
  ? new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Paris' }).format(new Date(typeof value === 'number' ? value : Date.parse(value)))
  : '—';
